export default __webpack_public_path__ + "static/media/Oswald-Bold.7cbe6aaa.ttf";